export default __webpack_public_path__ + "static/media/73.bd3eac24.jpg";